export class stickyMenu {
    constructor() {
        jQuery(document).ready(function($) {
            if ($('.c-header--isHomepage [data-sticky-container]').length > 0) {
                var offset=168;
                var stickyNav = function() {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop >= offset) {
                        $('[data-sticky-container]').addClass('fixed');
                        $('[data-sticky-logo-big]').removeClass('d-md-block');
                        $('[data-sticky-logo-small]').removeClass('d-none');
                    } else {
                        $('[data-sticky-container]').removeClass('fixed');
                        $('[data-sticky-logo-big]').addClass('d-md-block');
                        $('[data-sticky-logo-small]').addClass('d-none');
                    }
                };
                stickyNav();
                $(window).scroll(function() {
                    stickyNav();
                });
            }
        });
    }
}